module.exports = __webpack_public_path__ + "img/no-data.98023dd5.png";